import EventClass from "common/utils/ui/event-class";
import "./digital-assets-asset-card-search-score.scss";

export class DigitalAssetsCardSearchScore extends EventClass {
  constructor({ eventSelector }) {
    super({ eventSelector });
  }

  // eslint-disable-next-line class-methods-use-this
  event({ target }) {
    const { explain } = target.dataset;
    if (explain) {
      try {
        console.log(JSON.parse(explain));
      } catch (err) {
        console.log(err);
      }
    }
  }
}

export default () =>
  new DigitalAssetsCardSearchScore({
    eventSelector: ".js-search-score"
  });
